const logoPath = require("../assets/img/logo.png");
const bannerPath = require("../assets/img/login-banner.png");

const defaultTenant = {
  tenantId: "default",
  brandName: "Radiyantra",
  logoUrl: logoPath,
  loginBannerUrl: bannerPath,
  faviconUrl: null,
  supportPhone: "+91 7877066913",
  supportEmail: "support@radiyantra.com",
  tagline: "AI-powered PACS diagnostic platform for seamless radiology reporting.",
  theme: {
    primaryColor: "#2563eb",
    primaryColorDark: "#1d4ed8",
    primaryHover: "#3b82f6",
    sidebarBg: "#1a2035",
    headerBg: "#ffffff",
    accentColor: "#34d399",
    sidebarText: "#b3b9c4",
    sidebarActive: "#ffffff",
    fontFamily: "'Poppins', sans-serif",
  },
  features: {
    aiDictation: true,
    aiStructure: true,
    aiImpression: true,
    criticalCheck: true,
    chat: true,
    digitalSharing: true,
    seeDoctor: true,
    manageUsers: true,
    manageGrades: true,
    managePriorities: true,
    manageTemplates: true,
    manageCategories: true,
    machine: true,
    radiologistSlots: true,
    timeline: true,
  },
  apiBaseUrl: process.env.REACT_APP_BASE_URL || "http://localhost:3002/v1",
  ohifViewerUrl:
    process.env.REACT_APP_OHIF_VIEWER_URL || "http://localhost:3000/viewer",
  orthancUrl: process.env.REACT_APP_ORTHANC_URL || "http://localhost:8050",
};

export default defaultTenant;
